import { Stack } from "@similarweb/ui-components/foundations";

import { generateAutomationName } from "app/pages/activation/helpers/generateAutomationName";

import { INSIGHTS_SKELETON_ROW_COUNT } from "./insightsLoading.constants";
import { InsightRowSkeleton } from "./InsightRowSkeleton";
import * as SC from "./styles";

export const InsightsLoader = () => (
    <SC.InsightsBodyLoaderRoot data-automation={generateAutomationName("home", ["insights", "panel", "body-loader"])}>
        <Stack
            gap="12px"
            width="100%"
        >
            {Array.from({ length: INSIGHTS_SKELETON_ROW_COUNT }, (_, index) => (
                <InsightRowSkeleton
                    key={`insight-skeleton-${String(index)}`}
                    index={index}
                />
            ))}
        </Stack>
    </SC.InsightsBodyLoaderRoot>
);
